<template>
  <div class="bill-query">
    <select-meter class="select-meter"></select-meter>
    <div class="cost-cards">
      <div class="card-shadow">
        <div class="card-title">
          <span>本月電費</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>$ {{ current_bill }}</span>
        </div>
      </div>
      <div class="card-shadow">
        <div class="card-title">
          <span>本月電度</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>{{ current_usage }} kWh</span>
        </div>
      </div>
      <div class="card-shadow">
        <div class="card-title">
          <span>上月電費</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>$ {{ previous_bill }}</span>
        </div>
      </div>
      <div class="card-shadow">
        <div class="card-title">
          <span>上月電度</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>{{ previous_usage }} kWh</span>
        </div>
      </div>
      <div class="card-shadow">
        <div class="card-title">
          <span>去年同月電費</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>$ {{ last_year_bill }}</span>
        </div>
      </div>
      <div class="card-shadow">
        <div class="card-title">
          <span>去年同月電度</span>
        </div>
        <div class="card-context">
          <img :src="base_url + '/images/icons/1.png'" alt="">
          <!-- <img :src="base_url + '/images/icons/2.png'" alt=""> -->
          <span>{{ last_year_usage }} kWh</span>
        </div>
      </div>
    </div>

    <div class="current-bill">
      <div class="card-title">
        <div class="card-icon"><img :src="base_url + '/images/icons/16.png'" alt=""></div>
        <span>當日電費</span>
      </div>
      <div class="card-content">
        <div class="circuits-data">
          <div v-for="meterUsage, index in dailyCircuitUsage" :key="index">
            <span>{{ meterUsage.alias }}</span><br>
            <span>{{ meterUsage.cumulative_ep }} kWh</span>
          </div>
        </div>
        <div class="estimate-cost">
          <div>
            電費預估<br>
            <span>$ {{ daily_bill }}</span>
          </div>
        </div>
      </div>
    </div>
    <render-chart class="render-chart chart-padding" />
  </div>
</template>

<script>
import RenderChart from '../charts/RenderChart.vue';
import SelectMeter from '../buttons/SelectMeter.vue';
import { powerCostCalculation } from '../mixins/powerCostCalculation';

export default {
  data() {
    return {
      base_url: base_url,
      current_usage: '',
      current_bill: '',
      previous_usage: '',
      previous_bill: '',
      last_year_usage: '',
      last_year_bill: '',
      daily_bill: '',
      daily_kWh_this_month: [],
      cost_usage_type: 'residential',
    };
  },
  mixins: [powerCostCalculation],
  components: {
    RenderChart,
    SelectMeter,
  },
  mounted() {
    console.log('--bill-- bill query mounted');
    this.$store.commit('setHistoricalDataTimeFormat', 'day');
    this.$store.commit('setDataType', 'barChart')
    this.getElectricityUsage();
  },
  computed: {
    dailyCircuitUsage() {
      const circuits = this.meter.bx_circuits;
      if (!circuits) {
        return null;
      }
      const circuit_keys = Object.keys(circuits);
      let data = [];
      let count = 0;

      for (let i = 0; i < circuit_keys.length; i++) {
        let cumulative_data = [];
        cumulative_data = circuits[i].cumulative_data.filter(value => value.cumulative_ep !== "");
        if (cumulative_data.length > 0) {
          let cumulative_ep = cumulative_data[cumulative_data.length - 1].cumulative_ep;
          if (i === 0) {
            this.daily_bill = this.calculateElectricityBill(Math.abs(cumulative_ep), this.bill_mode);
          }
          data[count] = {
            alias: circuits[i].alias,
            cumulative_ep: Math.abs(cumulative_ep),
          };
          count++
        }
      }
      return data;
    },
    request_date() {
      return this.$store.getters.requestDate;
    },
    meter() {
      return this.$store.getters.selectedMeter;
    },
    bill_mode() {
      return this.$store.getters.billMode;
    }
  },
  watch: {
    meter() {
      console.log('--bill-- meter changed');
      // wait 1000ms to make sure the meter is updated
      setTimeout(() => {
        this.getElectricityUsage();
      }, 1000);
    },
    bill_mode() {
      this.calcBill();
    },
    deep: true,
  },
  methods: {
    getElectricityUsage() {
      console.log('--bill-- call bx log month api');
      this.$store.commit('setShowSpinner', true);
      let date = new Date(this.request_date);
      const params = [
        { usage: 'current_usage', date: new Date(date.getFullYear(), date.getMonth(), date.getDate()) },
        { usage: 'previous_usage', date: new Date(date.getFullYear(), date.getMonth() - 1, date.getDate()) },
        { usage: 'last_year_usage', date: new Date(date.getFullYear() - 1, date.getMonth(), date.getDate()) }
      ];
      let promises = params.map(param => {
        const axios_data = {
          year: param.date.getFullYear(),
          month: param.date.getMonth() + 1,
          day: param.date.getDate(),
          circuit_id: this.meter.bx_circuits[0].id, // 總用電
          mac: this.meter.bx_mac,
        }
        return axios.post(`${base_url}/api/bx/log/month`, axios_data).then((response) => {
          let daily_kWh = [];
          daily_kWh = response.data.cumulative_data.filter(value => { if (value.kWh !== null && value.kWh !== "") { return value } });
          if (daily_kWh.length > 0) {
            if (param.usage === 'current_usage') {
              this.daily_kWh_this_month = daily_kWh;
              this.current_usage = daily_kWh[daily_kWh.length - 1].cumulative_ep;
            }
            if (param.usage === 'previous_usage') {
              this.previous_usage = daily_kWh[daily_kWh.length - 1].cumulative_ep;
            }
            if (param.usage === 'last_year_usage') {
              this.last_year_usage = daily_kWh[daily_kWh.length - 1].cumulative_ep;
            }
          }
        }).catch((error) => { console.log(error) });
      })

      Promise.all(promises).then(() => {
        console.log('--bill-- done bx log month api');
        this.calcBill()
      });
    },
    calcBill() {
      console.log('--bill-- 計算電費')
      this.current_bill = this.calculateElectricityBill(this.current_usage, this.bill_mode);
      this.previous_bill = this.calculateElectricityBill(this.previous_usage, this.bill_mode);
      this.last_year_bill = this.calculateElectricityBill(this.last_year_usage, this.bill_mode);
      this.calcDailyBill();
    },
    calcDailyBill() {
      const cost_result = this.daily_kWh_this_month.map(value => {
        return {
          electricityCost: this.calculateElectricityBill(Math.abs(value.kWh), this.bill_mode),
          time: value.time,
        }
      })
      console.log('--bill-- 當月電費趨勢');
      this.$store.commit('setDailyBillThisMonth', cost_result);
    }
  }
}
</script>

<style scoped>
.bill-query {
  width: 100%;
  padding: 1vh 2vw 1vh 2vw;
}

.bill-query .chart-padding {
  padding: 0 2% 5% 2%;
}

.bill-query .card-shadow {
  border-radius: 1rem;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding: 1%;
}

.bill-query .select-meter {
  height: 15vh;
  margin-bottom: 1vh;
}

.bill-query .cost-cards {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 35vh;
}

.bill-query .cost-cards > div {
  width: 48%;
  height: 31%;
}

.bill-query .cost-cards > div .card-title {
  padding-left: 5%;
  padding-top: 2%;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid var(--bx-unselected-btn);
  height: 30%;
  min-height: 2rem;
}

.bill-query .cost-cards > div .card-title > span {
  font-size: 1.1rem;
  font-weight: bolder;
}

.bill-query .cost-cards > div .card-context {
  width: 100%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bill-query .cost-cards > div .card-context > img {
  width: 20%;
  margin-right: 5%;
  display: none;
}

.bill-query .cost-cards > div .card-context > span {
  font-size: 1.2rem;
  font-weight: bolder;
}

.bill-query .render-chart {
  margin-top: 1vh;
  height: 25vh;
  min-height: 230px;
}

.bill-query .current-bill {
  background-color: #069610;
  margin-top: 1vh;
  border-radius: 1rem;
  font-size: .8rem;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 25vh;
  min-height: 250px;
}

.bill-query .current-bill .card-title {
  display: flex;
  align-items: center;
  padding-left: 4%;
  margin: 0;
  min-height: 3rem;
  height: 15%;
}

.bill-query .current-bill .card-title > span {
  color: white;
  font-size: .9rem;
  font-weight: bolder;
  margin-left: .5rem;
}

.bill-query .current-bill .card-title .card-icon {
  width: 1.8rem;
  height: 1.8rem;
  background-color: white;
  border-radius: .3rem;
}

.bill-query .current-bill .card-title .card-icon > img {
  margin: 15%;
  width: 70%;
  height: 70%;
}

.bill-query .current-bill .card-content {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 3rem);
}

.bill-query .current-bill .card-content .circuits-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  width: 65%;
  padding-left: 2%;
}

.bill-query .current-bill .card-content .circuits-data > div {
  margin: 1% 0 2% 0;
  min-width: 35%;
  max-width: 45%;
}

.bill-query .current-bill .card-content .estimate-cost {
  width: 35%;
  height: 100%;
  padding: 2%;
}

.bill-query .current-bill .card-content .estimate-cost > div > span {
  font-size: 2rem;
  font-weight: bolder;
}
</style>
